import WebHIDTypes from './webHID.types';
import WebHIDState from './webHID.state';
import { WebHIDAction } from './webHID.actions';

const defaultState : WebHIDState = {
    showWebHIDPairButton: false,
    webHIDinCall: false,
    ignoreDeviceSignals: true,
    deviceIsMuted: false,
}

export default function (state = defaultState, action: WebHIDAction): WebHIDState {
    switch (action.type) {
        case WebHIDTypes.SHOW_WEBHID_PAIR_BUTTON:
            return { ...state!, showWebHIDPairButton: true };
        case WebHIDTypes.HIDE_WEBHID_PAIR_BUTTON:
            return { ...state!, showWebHIDPairButton: false };
        case WebHIDTypes.SET_WEBHID_IN_CALL:
            return { ...state!, webHIDinCall: action.payload };
        case WebHIDTypes.SET_IGNORE_DEVICE_SIGNALS:
            return { ...state!, ignoreDeviceSignals: action.payload };
            case WebHIDTypes.SET_CONNECTED_HEADSET: 
            return { ...state!, connectedHeadset: action.payload }
        default:
            return state;
    }
}
